import React from "react";
import './intro.css';
import btnImg from '../../assets/resume.png';

const Intro = () => {
    const redirectToWebsite = () => {
        window.open('https://drive.google.com/file/d/1RZmcqk5-qfQrCxXDbMR35a6CA8THRMny/view?usp=sharing', '_blank');
    };

    return (
       <section id="intro">
            <div className="introContent">
                <span className="hello">Hello</span>
                <span className="introText">I'm <span className="introName">Sree Krishnan</span> <br />Software Engineering Trainee</span>
                <p className="introPara">I am a Full Stack Developer, passionate about working with challenging tasks whether it be technological or situational.<br />Currently in upskilling mode every day and every moment that favors me.</p>
                <button className="websiteButton" onClick={redirectToWebsite}>
                    <img src={btnImg} alt="Resume" /> 
                    My Resume
                </button>
            </div>
       </section> 
    )
}

export default Intro;
